import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { fetchJobProtocol } from '../../lib/crmClient';
import './job-protocol.css';

const JobProtocolButton = ({ job }) => {
  const [open, setOpen] = useState(false);
  const [preview, setPreview] = useState(null);
  const [error, setError] = useState('');
  const dialogRef = useRef(null);
  const buttonRef = useRef(null);
  const jobId = job.ZakazkaId;

  useEffect(() => {
    if (!open) return undefined;
    const dialog = dialogRef.current;
    const trigger = buttonRef.current;
    const controller = new AbortController();
    dialog.showModal();
    setPreview(null);
    setError('');
    fetchJobProtocol({ zakazkaId: jobId, signal: controller.signal }).then((result) => {
      if (controller.signal.aborted) return;
      if (!result?.url || new URL(result.url).protocol !== 'https:') throw new Error('Odkaz na protokol není dostupný.');
      setPreview(result);
    }).catch((reason) => {
      if (!controller.signal.aborted) setError(reason.message || 'Protokol se nepodařilo načíst.');
    });
    return () => {
      controller.abort();
      dialog.close();
      if (trigger?.isConnected) trigger.focus();
    };
  }, [open, jobId]);

  if (!job.ProtokolBlobUrl) return null;

  return <>
    <button
      ref={buttonRef}
      type="button"
      className="btn table-action-icon-btn crm-job-protocol-button"
      title={`Zobrazit protokol zakázky #${jobId}`}
      aria-label={`Zobrazit protokol zakázky #${jobId}`}
      onClick={() => setOpen(true)}
    >
      <i className="bx bxs-file-image" aria-hidden="true" />
    </button>
    {open && createPortal(
      <dialog ref={dialogRef} className="crm-job-protocol-dialog" aria-labelledby={`job-protocol-title-${jobId}`} onCancel={() => setOpen(false)} onClose={() => setOpen(false)} onKeyDown={(event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          setOpen(false);
        }
      }}>
        <div className="crm-job-protocol-dialog__header">
          <h3 id={`job-protocol-title-${jobId}`}>Protokol zakázky #{jobId}</h3>
          {preview && <a className="btn table-action-icon-btn" href={preview.url} target="_blank" rel="noopener noreferrer" title="Otevřít originál v nové záložce" aria-label="Otevřít originál v nové záložce"><i className="bx bx-link-external" aria-hidden="true" /></a>}
          <button autoFocus type="button" className="btn table-action-icon-btn" title="Zavřít protokol" aria-label="Zavřít protokol" onClick={() => setOpen(false)}><i className="bx bx-x" aria-hidden="true" /></button>
        </div>
        <div className="crm-job-protocol-dialog__body">
          {error ? <p className="crm-error" role="alert">{error}</p> : !preview ? <p role="status">Načítám protokol...</p> : null}
          {preview?.kind === 'image' && !error && <img src={preview.url} alt={`Protokol zakázky #${jobId}`} onError={() => setError('Náhled se nepodařilo načíst. Zkuste otevřít originál.')} />}
          {preview?.kind === 'pdf' && <iframe src={preview.url} title={`Protokol zakázky #${jobId}`} />}
          {preview?.kind === 'file' && <a href={preview.url} target="_blank" rel="noopener noreferrer">Otevřít soubor protokolu</a>}
        </div>
      </dialog>, document.body
    )}
  </>;
};

export default JobProtocolButton;